module.exports = __webpack_public_path__ + "img/character-in-fail.270bfb5f.png";